"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonTypes = exports.BalanceOf = exports.LookupSource = exports.Address = exports.AccountId = exports.BalanceKind = exports.WorkingGroup = exports.WorkingGroupDef = exports.InputValidationLengthConstraint = exports.OptionText = exports.getOptionPropOrUndefined = exports.getBoolPropAsBoolean = exports.getTextPropAsString = exports.BlockAndTime = exports.Hash = exports.PostId = exports.ThreadId = exports.ChannelId = exports.Url = exports.MemberId = exports.ActorId = exports.BlockNumber = exports.Balance = exports.JoyStructDecorated = exports.JoyStructCustom = exports.JoyEnum = void 0;
const types_1 = require("@polkadot/types");
// we get 'moment' because it is a dependency of @polkadot/util, via @polkadot/keyring
const moment_1 = __importDefault(require("moment"));
const JoyStruct_1 = require("./JoyStruct");
Object.defineProperty(exports, "JoyStructCustom", { enumerable: true, get: function () { return JoyStruct_1.JoyStructCustom; } });
Object.defineProperty(exports, "JoyStructDecorated", { enumerable: true, get: function () { return JoyStruct_1.JoyStructDecorated; } });
const JoyEnum_1 = require("./JoyEnum");
Object.defineProperty(exports, "JoyEnum", { enumerable: true, get: function () { return JoyEnum_1.JoyEnum; } });
const AccountId_1 = require("@polkadot/types/generic/AccountId");
class Balance extends types_1.u128 {
}
exports.Balance = Balance;
class BlockNumber extends types_1.u32 {
}
exports.BlockNumber = BlockNumber;
class ActorId extends types_1.u64 {
}
exports.ActorId = ActorId;
class MemberId extends types_1.u64 {
}
exports.MemberId = MemberId;
class Url extends types_1.Text {
}
exports.Url = Url;
class ChannelId extends types_1.u64 {
}
exports.ChannelId = ChannelId;
// Indentical type names for Forum and Proposal Discussions modules
// Ensure they are both configured in runtime to have same type
class ThreadId extends types_1.u64 {
}
exports.ThreadId = ThreadId;
class PostId extends types_1.u64 {
}
exports.PostId = PostId;
class Hash extends types_1.U8aFixed {
}
exports.Hash = Hash;
class BlockAndTime extends (0, JoyStruct_1.JoyStructDecorated)({ block: types_1.u32, time: types_1.u64 }) {
    get momentDate() {
        const YEAR_2000_MILLISECONDS = 946684801000;
        // overflowing in ~270,000 years
        const timestamp = this.time.toNumber();
        // TODO: remove once https://github.com/Joystream/joystream/issues/705 is resolved
        // due to a bug, timestamp can be either in seconds or milliseconds
        let timestampInMillis = timestamp;
        if (timestamp < YEAR_2000_MILLISECONDS) {
            // timestamp is in seconds
            timestampInMillis = timestamp * 1000;
        }
        return (0, moment_1.default)(timestampInMillis);
    }
}
exports.BlockAndTime = BlockAndTime;
function getTextPropAsString(struct, fieldName) {
    return struct.get(fieldName).toString();
}
exports.getTextPropAsString = getTextPropAsString;
function getBoolPropAsBoolean(struct, fieldName) {
    return struct.get(fieldName).valueOf();
}
exports.getBoolPropAsBoolean = getBoolPropAsBoolean;
function getOptionPropOrUndefined(struct, fieldName) {
    return struct.get(fieldName).unwrapOr(undefined);
}
exports.getOptionPropOrUndefined = getOptionPropOrUndefined;
class OptionText extends types_1.Option.with(types_1.Text) {
}
exports.OptionText = OptionText;
class InputValidationLengthConstraint extends (0, JoyStruct_1.JoyStructDecorated)({
    min: types_1.u16,
    max_min_diff: types_1.u16,
}) {
    get max() {
        return this.registry.createType('u16', this.min.add(this.max_min_diff));
    }
}
exports.InputValidationLengthConstraint = InputValidationLengthConstraint;
exports.WorkingGroupDef = {
    Forum: types_1.Null,
    Storage: types_1.Null,
    Content: types_1.Null,
    OperationsAlpha: types_1.Null,
    Gateway: types_1.Null,
    Distribution: types_1.Null,
    OperationsBeta: types_1.Null,
    OperationsGamma: types_1.Null,
    Membership: types_1.Null,
};
class WorkingGroup extends (0, JoyEnum_1.JoyEnum)(exports.WorkingGroupDef) {
}
exports.WorkingGroup = WorkingGroup;
class BalanceKind extends (0, JoyEnum_1.JoyEnum)({
    Positive: types_1.Null,
    Negative: types_1.Null,
}) {
}
exports.BalanceKind = BalanceKind;
// @polkadot/types overrides required since migration to Substrate 2.0,
// see: https://polkadot.js.org/docs/api/FAQ#i-cannot-send-transactions-sending-yields-address-decoding-failures
class AccountId extends AccountId_1.GenericAccountId {
}
exports.AccountId = AccountId;
class Address extends AccountId {
}
exports.Address = Address;
class LookupSource extends AccountId {
}
exports.LookupSource = LookupSource;
class BalanceOf extends Balance {
}
exports.BalanceOf = BalanceOf;
exports.commonTypes = {
    ActorId,
    MemberId,
    BlockAndTime,
    ThreadId,
    PostId,
    InputValidationLengthConstraint,
    WorkingGroup,
    BalanceKind,
    // Customize Address type for joystream chain
    Address,
    LookupSource,
    ChannelId,
    Url,
};
exports.default = exports.commonTypes;
